import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/man.svg'


const _withScopeId = n => (_pushScopeId("data-v-4b01f344"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex h-screen justify-center gap-4 items-center flex-col w-full" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "465",
  height: "374",
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "text-xl" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "button-back p-3 rounded-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('errors.oops')), 1),
    _createElementVNode("div", _hoisted_4, [
      _createTextVNode(_toDisplayString(_ctx.$t('errors.message.sorry_but')) + " ", 1),
      _hoisted_5,
      _createTextVNode(_toDisplayString(_ctx.$t('errors.message.not_found')), 1)
    ]),
    _createVNode(_component_router_link, { to: "/" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('errors.back_to')), 1)
      ]),
      _: 1
    })
  ]))
}